import {
  ContactFormDocument,
  SubscribeToEmailDocument
} from "../graphql/Contact.mjs";
import { useMutation } from "villus";
import { reactive } from "vue";
export function useContactForm() {
  const { execute } = useMutation(ContactFormDocument);
  const input = reactive({
    name: "",
    email: "",
    phone_number: "",
    description: "",
    reason_of_contact: "",
    attachment: ""
  });
  async function submitForm() {
    const { error } = await execute({
      input
    });
    if (error) {
      throw error;
    }
  }
  return {
    /**
     * The reactive state object containing the contact form input fields.
     * @type {object}
     * @property {string} name - The name of the user submitting the form.
     * @property {string} email - The email of the user submitting the form.
     * @property {string} phone_number - The phone number of the user submitting the form.
     * @property {string} description - The user's message or inquiry.
     * @property {string} reason_of_contact - The reason for the user's inquiry.
     * @property {string} attachment - An optional base64 encoded file attachment.
     */
    input,
    /**
     * Submits the contact form data to the server.
     *
     * @async
     * @throws {Error} If the mutation fails.
     */
    submitForm
  };
}
export function useSubscribeToNewsletter() {
  const { execute } = useMutation(SubscribeToEmailDocument);
  async function submitForm(email) {
    const { error } = await execute({
      email
    });
    if (error) {
      throw error;
    }
  }
  return {
    /**
     * Submits the email for newsletter subscription to the server.
     *
     * @async
     * @param {string} email - The email address to subscribe to the newsletter.
     * @throws {Error} If the mutation fails.
     */
    submitForm
  };
}
